import(/* webpackMode: "eager" */ "/root/repo/src/app/score-check/skills/page.tsx");
